import type { PatientNavigatorItemData } from './types';

type PolicyRelationship = PatientNavigatorItemData['policyRelationship'];

/**
 * Clinician-facing label for each policy relationship. The underlying code
 * values (`actionable` / `licensed` / `unlicensed`) describe the
 * clinician–patient policy match and are not designed for end-user reading;
 * surfaces should always render this label rather than the raw value.
 */
export const POLICY_RELATIONSHIP_LABEL: Record<PolicyRelationship, string> = {
  actionable: 'Ready for you',
  licensed: 'Licensed',
  unlicensed: 'Outside license',
};

/**
 * Optional long-form explanation for hover tooltips and assistive tech.
 * Only set for relationships whose copy has been approved; consumers should
 * fall back to no tooltip when a value is absent.
 */
export const POLICY_RELATIONSHIP_DESCRIPTION: Partial<Record<PolicyRelationship, string>> = {
  actionable:
    'You’re licensed in this patient’s state and the practice areas align — you can chart this patient now.',
};
